import { TableStyleType } from './table-style.interface';
import { TableDarkTheme } from './table.dark-theme';

export const TableLightTheme: TableStyleType = TableDarkTheme;
